import { render } from "./BatchElevatorParts.vue?vue&type=template&id=5422d4c6"
import script from "./BatchElevatorParts.vue?vue&type=script&lang=js"
export * from "./BatchElevatorParts.vue?vue&type=script&lang=js"

import exportComponent from "/Users/user/Desktop/prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__